export const config = {
   url: "https://sssdata-c89aa95c7590.herokuapp.com",
    // url: "http://localhost:4000",
    contract: "ECfKJdm7dXC1BcCMEy5ZXrSUFVDfghEgVNKA6WYq7bSy",
    token: "8Hg4FJBpQKjRCTqmFdhhn7RCvHCn2qQbZUbfBjdk9bK2"
}